import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4dcac61e")

_pushScopeId("data-v-4dcac61e")
const _hoisted_1 = { class: "twoBytwo-orderstyle" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "番号のスタイル：", -1)
const _hoisted_3 = { class: "select" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderStyles, ([key, val]) => {
        return (_openBlock(), _createBlock("div", {
          class: "item",
          key: key
        }, [
          _createVNode("input", {
            id: `orderstyle_${key}`,
            type: "radio",
            name: "orderStyle",
            value: key,
            checked: key == _ctx.orderStyle,
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)))
          }, null, 40, ["id", "value", "checked"]),
          _createVNode("label", {
            for: `orderstyle_${key}`
          }, [
            _createVNode("img", {
              src: val,
              width: "61"
            }, null, 8, ["src"])
          ], 8, ["for"])
        ]))
      }), 128))
    ])
  ]))
})